import { render, staticRenderFns } from "./ProtocolosImprimir.vue?vue&type=template&id=7e56ddcc&scoped=true&"
import script from "./ProtocolosImprimir.vue?vue&type=script&lang=js&"
export * from "./ProtocolosImprimir.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolosImprimir.vue?vue&type=style&index=0&id=7e56ddcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56ddcc",
  null
  
)

export default component.exports